<template>
    <div class="">
        <div v-if="filter" class="d-flex flex-wrap justify-content-center align-items-center pb-sm">
            <h4 class="text-blue-dark mb-2 mb-lg-0 mr-3 d-flex d-lg-inline-flex w-100 w-lg-auto justify-content-center">Filter by:</h4>
            <button v-for="category in categories"
                v-on:click="filterByCategory(category)"
                :key="category.id"
                :class="[
                    'btn' , 'btn-sm' , 'btn-outline-blue-dark' , 'mb-2', 'mb-lg-0',
                    'rounded-pill' , 'mx-1' , 'd-flex' , 'align-items-center' ,
                    currentCategory == category.id ? 'active' : '',
                ]">
                <i v-if="currentCategory == category.id" class="material-icons">done</i>{{ category.name }}
            </button>
        </div>


        <div class="row owl-carousel owl-mob owl-theme">
            <div class="col-xl-4 mb-4" v-for="news in items" :key="news.id" >
                <a :href="getNewsPath(news)" class="card h-100 box-shadow card--hover card--hover--no-footer position-relative">
                    <div class="card-header position-relative p-0 flex-shrink-0">
                        <img class="img-fluid lazyload blur-up"
                            :src="_.imgPath(news.attributes.image_thumbnail, 'w1088-h474-c1088x474-q10')"
                            :data-src="_.imgPath(news.attributes.image_thumbnail, 'w1088-h474-c1088x474-q80')"
                            :alt="news.attributes.name">
                    </div>
                    <div class="card-body pb-0">
                        <!-- <span v-if="!_.isEmpty(_.get(news, 'attributes.categories', []))" v-html="getNewsCategories(news)" -->
                        <!--     class="card--label position-absolute bg-primary text-white text-uppercase"></span> -->
                        <h4 class="heading-underline heading-underline__sm heading-underline__blue-light">{{ news.attributes.name }}</h4>
                        <p class="card--intro text-color" v-html="news.attributes.intro"></p>
                    </div>

                     <div class="card-footer bg-white border-0 pt-0 pb-0">
                  <!--  <p  v-if="_.get(news, 'attributes.available_at')"
                            class="mb-0 text-uppercase small text-grey">
                            <strong>{{ formatDate(news.attributes.available_at) }}</strong>
                        </p>  -->
                    </div>
                </a>
            </div>
        </div>

       <!--  <div v-if="hasMore" class="text-center">
            <button v-if="loading"
                class="btn btn-primary btn-lg rounded-pill text-uppercase disabled">
                Loading...
            </button>
            <button v-else
                v-on:click="loadNews"
                class="btn btn-primary btn-lg rounded-pill text-uppercase">
                Load more
            </button>
        </div> -->
    </div>
</template>
<script>

const M = importLib('moment');

import UtilsMixin from './UtilsMixin';

export default {
    data() {
        return {
            currentCategory: null,
            currentDate: null,
            items: [],
            meta: {},
            page: 0,
            loading: false,
        }


    },

    created() {
        this.items = _.get(this.initialData, 'items.data', []);
        if (_.isEmpty(this.items)) {
            this.loadNews();
        }
    },

    mounted() {

    },

    props: ['initialData', 'config'],

    components: {

    },

    mixins: [UtilsMixin],

    watch: {
        currentCategory(newVal) {
            this.page = 0;
            this.loadNews(false);
        },
    },

    mounted() {
        this.triggerEvents();

        $("h2,h3,h4").each(function () {
            $(this).html($(this).html().replace(/&reg;/gi, '<sup>&reg;</sup>').replace(/®/gi, '<sup>&reg;</sup>').replace('<sup><sup>', '<sup>').replace('</sup></sup>', '</sup>'));
        });
    },

    computed: {
        categories() {
            let categories = _.chain(this.initialData)
                .get('categories')
                .value();

            return _.concat([{ id: null, name: 'All' }], categories);
        },

        filter() {
            return _.get(this.config, 'filter', true);
        },

        hasMore() {
            return _.get(this.meta, 'last_page') > this.page;
        },
    },

    methods: {
        getNewsCategory(post) {
            return _.chain(this.initialData)
                .get('categories')
                .find(cat => cat.id == post.news_category_id)
                .value();
        },

        getNewsPath(post) {
            return '/projects-stories/' + post.attributes.name_id;
        },

        filterByDate(date) {
            this.currentDate = date;
        },

        filterByCategory(cat) {
            this.currentCategory = cat.id;
        },

        formatDate(date) {
            return M(date, 'YYYY-MM-DD hh:mm:ss').format('D MMM YYYY');
        },

        loadNews(append = true) {
            this.loading = true;
            this.page = this.page + 1;
            this.api.getData('/news_posts', {
                per_page: 9,
                page: this.page,
                'filter[id(a)]': '$active',
                'sort[position]': 'desc',
                'filter[id(c)]': this.currentCategory ? `$belongsto(categories,${this.currentCategory})` : '',
            }).then(res => {
                this.meta = res.meta;

                if (append) {
                    this.items = _.chain(this.items)
                        .concat(res.data)
                        .value();
                } else {
                    this.items = res.data;
                }

            }).finally(() => {
                this.loading = false;
                this.$nextTick(() => {
                    this.triggerEvents();
                })
            })

        },

        getNewsCategories(news) {
            let text = _.chain(news)
                .get('attributes.categories', [])
                .sortBy('position')
                .map('name')
                .differenceBy(['projects', 'news'], _.toLower) // not showing projects and news
                .join(' / ');

            return `<span>${text}</span>`;
        },

        triggerEvents() {
            if ($('.card--hover').length) {
                var bodyHeight = $('.card--hover .card-body').outerHeight();
                var imgHeight = $('.card--hover .header-img').outerHeight();

                $( ".card--hover .card-footer" ).css( "margin-top", bodyHeight );
                // $( ".card--hover .card-body" ).css( "bottom", 45);
                $( ".card--hover--no-footer .card-body" ).css( "bottom", 0);
            };

        }

    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/site/js/components/NewsListCarouselComponent.vue